export enum RoleFunctionName {
  // Sub-module parents (used for grouping in access matrix UI)
  PurchaseRequest = 'PurchaseRequest',
  ItemManagement = 'ItemManagement',
  Procedures = 'Procedures',
  Approval = 'Approval',
  Profile = 'Profile',
  AdminPanel = 'AdminPanel',
  Agreements = 'Agreements',

  // Purchase Request
  PurchaseRequestViewOwn = 'PurchaseRequest.ViewOwn',
  PurchaseRequestViewAll = 'PurchaseRequest.ViewAll',
  PurchaseRequestEditOwn = 'PurchaseRequest.EditOwn',
  PurchaseRequestEditAll = 'PurchaseRequest.EditAll',

  // Items
  ItemsView = 'Items.View',
  ItemsEdit = 'Items.Edit',

  // Procedures
  ProceduresViewOwn = 'Procedures.ViewOwn',
  ProceduresViewAll = 'Procedures.ViewAll',
  ProceduresEditOwn = 'Procedures.EditOwn',
  ProceduresEditAll = 'Procedures.EditAll',
  ProceduresParticipate = 'Procedures.Participate',

  // Approval
  ApprovalViewTask = 'Approval.ViewTask',
  ApprovalManageRoutes = 'Approval.ManageRoutes',
  ApprovalManageGroups = 'Approval.ManageGroups',
  ApprovalViewGroups = 'Approval.ViewGroups',

  // Profile & Company
  ProfileView = 'Profile.View',
  ProfileEdit = 'Profile.Edit',
  SuppliersView = 'Suppliers.View',
  SuppliersEdit = 'Suppliers.Edit',
  StaffView = 'Staff.View',
  StaffEdit = 'Staff.Edit',

  // Admin
  AdminView = 'Admin.View',
  AdminEdit = 'Admin.Edit',

  // Agreements
  AgreementsViewOwn = 'Agreements.ViewOwn',
  AgreementsViewAll = 'Agreements.ViewAll',
  AgreementsEditOwn = 'Agreements.EditOwn',
  AgreementsEditAll = 'Agreements.EditAll',

  // Platform (not tied to a seeded Function entity)
  SuperAdmin = 'SuperAdmin',
}
